/**
 * Summary — the date / duration / capacity / price summary rows in the publish modal.
 *
 * Extracted from PublishConfirmModal so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
import type { WorkshopDetail } from '../../../../api/workshops';

import { scheduleSummary } from './publishModalHelpers';
import { ScheduleWarning } from './ScheduleWarning';
import { formatPrice } from './workshopFields';

/** Date + duration, capacity, and price — the at-a-glance facts. */
export function Summary({ workshop }: { workshop: WorkshopDetail }) {
  const schedule = scheduleSummary(workshop);
  const rows: Array<{ label: string; value: string }> = [
    { label: 'When', value: schedule.value },
    { label: 'Capacity', value: String(workshop.capacity) },
    { label: 'Price', value: formatPrice(workshop.priceCents) },
  ];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <dl
        style={{
          margin: 0,
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          columnGap: 14,
          rowGap: 8,
          fontSize: 13,
        }}
      >
        {rows.map((r) => (
          <div key={r.label} style={{ display: 'contents' }}>
            <dt style={{ color: 'var(--nb-subtle)' }}>{r.label}</dt>
            <dd style={{ margin: 0, color: 'var(--nb-ink)', fontWeight: 600 }}>{r.value}</dd>
          </div>
        ))}
      </dl>
      {schedule.warning ? <ScheduleWarning message={schedule.warning} /> : null}
    </div>
  );
}

/** Teacher / assistants / trainees, grouped by position, resolved to names. */
